import { RemoteGetAllCurricularUnitsUser } from 'data/usecases/curricular-units';
import { GetAllCurricularUnitsUserUseCaseInterface } from 'domain/usecases/curricular-units';
import { makeApiUrlCurricularUnitsUser } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetAllCurricularUnitsUser =
  (): GetAllCurricularUnitsUserUseCaseInterface =>
    new RemoteGetAllCurricularUnitsUser(
      makeApiUrlCurricularUnitsUser(),
      makeAxiosHttpClient(),
    );
